export default __webpack_public_path__ + "static/media/scientific.2b61f15b.png";